module.exports = __webpack_public_path__ + "static/img/hzhb_zh.28abe28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_zh.png
// module id = +8hh
// module chunks = 0